import Styled from "styled-components";
import { maxQuery } from "../../../../helpers";

export default Styled.div`
  .riderDetails--container {
    background: #272B4A;
    border-radius: 8px;
    padding: 0;
    max-width: 700px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    
    ${maxQuery('md')} {
      max-width: 100%;
      max-height: 95vh;
    }

    header {
      padding: 1.5rem 2rem;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      background: #1f2238;
      border-radius: 8px 8px 0 0;
      position: sticky;
      top: 0;
      z-index: 10;
      
      ${maxQuery('md')} {
        padding: 1rem 1.5rem;
      }

      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        ${maxQuery('md')} {
          flex-direction: column;
          gap: 1rem;
          align-items: flex-start;
        }
      }
      
      h2 {
        color: #fff;
        font-size: 1.5rem;
        margin-bottom: 0.25rem;
        
        ${maxQuery('md')} {
          font-size: 1.25rem;
        }
      }

      p {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.875rem;
      }

      .header-actions {
        display: flex;
        gap: 0.75rem;
        
        ${maxQuery('md')} {
          width: 100%;
        }

        button {
          padding: 0.5rem 1rem;
          border-radius: 4px;
          font-size: 0.875rem;
          border: none;
          cursor: pointer;
          transition: all 0.2s;
          
          ${maxQuery('md')} {
            flex: 1;
            padding: 0.625rem;
          }

          &.btn-edit {
            background: ${({ theme }) => theme.primary};
            color: #fff;
            
            &:hover {
              opacity: 0.9;
            }
          }

          &.btn-delete {
            background: #dc3545;
            color: #fff;
            
            &:hover {
              background: #c82333;
            }
          }

          &.btn-save {
            background: #28a745;
            color: #fff;
            
            &:hover {
              background: #218838;
            }
          }

          &.btn-cancel {
            background: #6c757d;
            color: #fff;
            
            &:hover {
              background: #5a6268;
            }
          }
        }
      }
    }

    .tabs {
      display: flex;
      background: #1f2238;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      position: sticky;
      top: 89px;
      z-index: 9;
      
      ${maxQuery('md')} {
        top: 109px;
      }

      button {
        flex: 1;
        padding: 1rem;
        background: transparent;
        border: none;
        color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
        font-size: 0.875rem;
        font-weight: 500;
        transition: all 0.2s;
        border-bottom: 2px solid transparent;
        
        ${maxQuery('md')} {
          padding: 0.875rem 0.5rem;
          font-size: 0.75rem;
        }

        &:hover {
          color: rgba(255, 255, 255, 0.8);
          background: rgba(255, 255, 255, 0.03);
        }

        &.active {
          color: ${({ theme }) => theme.primary};
          border-bottom-color: ${({ theme }) => theme.primary};
        }
      }
    }

    .tab-content {
      padding: 2rem;
      
      ${maxQuery('md')} {
        padding: 1.5rem;
      }

      .detail-row {
        margin-bottom: 1.5rem;
        
        ${maxQuery('md')} {
          margin-bottom: 1.25rem;
        }

        label {
          display: block;
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.875rem;
          margin-bottom: 0.5rem;
          font-weight: 500;
        }

        p {
          color: #fff;
          font-size: 1rem;
          padding: 0.75rem;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.08);
          
          ${maxQuery('md')} {
            font-size: 0.875rem;
            padding: 0.625rem;
          }

          &.status {
            display: inline-block;
            padding: 0.5rem 1rem;
            border-radius: 20px;
            font-weight: 500;
            
            &.active {
              background: rgba(76, 175, 80, 0.2);
              color: #4CAF50;
              border: 1px solid #4CAF50;
            }
            
            &.inactive {
              background: rgba(255, 152, 0, 0.2);
              color: #FF9800;
              border: 1px solid #FF9800;
            }
            
            &.suspended {
              background: rgba(244, 67, 54, 0.2);
              color: #F44336;
              border: 1px solid #F44336;
            }
            
            &.unassigned {
              background: rgba(158, 158, 158, 0.2);
              color: #9E9E9E;
              border: 1px solid #9E9E9E;
            }
          }
        }

        input, select {
          width: 100%;
          padding: 0.75rem;
          background: #313446;
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          color: #fff;
          font-size: 1rem;
          
          ${maxQuery('md')} {
            font-size: 0.875rem;
            padding: 0.625rem;
          }

          &:focus {
            outline: none;
            border-color: ${({ theme }) => theme.primary};
          }

          &::placeholder {
            color: rgba(255, 255, 255, 0.4);
          }
        }

        select {
          cursor: pointer;
        }

        .btn-toggle-status {
          background: ${({ theme }) => theme.primary};
          margin-top: 0.5rem;
          
          &:hover {
            opacity: 0.9;
          }
        }
      }
    }

    .footer-actions {
      padding: 1.5rem 2rem;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      background: #1f2238;
      border-radius: 0 0 8px 8px;
      position: sticky;
      bottom: 0;
      
      ${maxQuery('md')} {
        padding: 1rem 1.5rem;
      }

      .btn-close {
        background: #6c757d;
        
        &:hover {
          background: #5a6268;
        }
      }
    }
  }
`;
